import { Document, Page, pdf, Text, View } from "@react-pdf/renderer"
import { styles, TableCell } from "components"
import moment from "moment"
import { cellValuePdf, RowExportTypePdf } from "types"
import { convertNumber } from "utils"
import { RegisterDateType } from "../../types"
import { calculateRegister } from "../function"
import { APPROVAL, DELIVERED } from "../vars"

type UseExportPdfDateRange = {
  data: RegisterDateType[]
  dateFilter: string
}

export const useExportPdfDateRange = ({
  data,
  dateFilter
}: UseExportPdfDateRange) => {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "SO ID#", key: "so_id", width: 25 },
    { header: "DATE", key: "date", width: 15 },
    { header: "CUSTOMER", key: "customer", width: 15 },
    { header: "APPROVAL", key: "approval", width: 15 },
    { header: "DELIVERED", key: "delivered", width: 15 },
    { header: "QTY ORDER", key: "qty_order", width: 15 },
    { header: "QTY DELIVERED", key: "qty_delivered", width: 15 },
    { header: "QTY BACK ORDER", key: "qty_back_order", width: 15 },
    { header: "TOTAL SALES", key: "total_sales", width: 15 },
    { header: "TOTAL PAYMENT", key: "total_payment", width: 15 },
    { header: "BALANCE OWING", key: "balance_owing", width: 15 }
  ]

  function numberFormat(value: number): cellValuePdf {
    return {
      text: convertNumber(value).intoCurrency,
      style: {
        textAlign: "right",
        fontWeight: "bold"
      }
    }
  }

  const calculate = calculateRegister(data)

  const dataMap: RowExportTypePdf[] = data.map((item, index) => {
    return {
      no: (index + 1).toString(),
      so_id: item.trx_code,
      date: moment(item.transaction_date).format("DD/MM/YYYY"),
      customer: item.customer_name,
      approval: APPROVAL[item.approval_status],
      delivered: DELIVERED[item.so_delivery_status],
      qty_order: numberFormat(item.qty_order),
      qty_delivered: numberFormat(item.qty_delivered),
      qty_back_order: numberFormat(item.qty_back_order),
      total_sales: numberFormat(item.total),
      total_payment: numberFormat(item.total_payment),
      balance_owing: numberFormat(item.balance_owing)
    }
  })

  return {
    handleExportPdf: () =>
      pdf(
        <PdfTemplate
          data={dataMap}
          title="REGISTER DATE RANGE"
          column={columns}
          date={dateFilter}
          balance={calculate.balance}
          payment={calculate.payment}
          sumQtyOrder={calculate.qty_order}
          sumQtyShipped={calculate.qty_delivered}
        />
      )
        .toBlob()
        .then((blob) => {
          const url = URL.createObjectURL(blob)
          const link = document.createElement("a")
          link.href = url
          link.download = `register-date-range-${dateFilter}.pdf`
          link.click()
          URL.revokeObjectURL(url)
        })
        .catch((error) => {
          console.error("Gagal membuat PDF:", error)
        })
  }
}

function PdfTemplate({
  data,
  title,
  column,
  date,
  balance,
  payment,
  sumQtyOrder,
  sumQtyShipped
}: {
  data: RowExportTypePdf[]
  title: string
  column: { header: string; key: string; width: number }[]
  date?: string
  balance: number
  payment: number
  sumQtyOrder:number
  sumQtyShipped:number
}) {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>SALES</Text>
        <Text style={styles.title}>{title}</Text>
        {date && <Text style={styles.date}>Date: {date}</Text>}
        <TableCell data={data} column={column} />
        <View
          style={{
            marginTop: 10,
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-end",
            alignItems: "flex-end"
          }}>

          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY QTY ORDER:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(sumQtyOrder).intoCurrency}
            </Text>
          </View>

          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY QTY SHIPPED:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(sumQtyShipped).intoCurrency}
            </Text>
          </View>


          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY PAYMENT:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(payment).intoCurrency}
            </Text>
          </View>

          <View
            style={[
              styles.date,
              {
                display: "flex",
                flexDirection: "row",
                fontSize: 8
              }
            ]}>
            <Text>SUMMARY BALANCE:</Text>
            <Text style={{ width: 50, textAlign: "right", paddingLeft: 2 }}>
              {convertNumber(balance).intoCurrency}
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  )
}
